import * as React from "react"

const Minus = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={4}
    viewBox="0 0 16 4"
    fill="none"
    {...props}
  >
    <path
      d="M1 2H15"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
    />
  </svg>
)
export default Minus
